import {Component, Input, OnInit} from 'ng-metadata/core';

@Component({
    selector: 'prm-union-catalog-login-institution-item',
    templateUrl: 'components/security/login/unionCatalogLogin/unionCatalogLoginInstitutionItem/union-catalog-login-institution-item.html',
})

export class PrmUnionCatalogLoginInstitutionItem implements OnInit{
    @Input() private institutionDetails;
    constructor() {
    }

    ngOnInit() {
    }

    get institutionName(){
        return this.institutionDetails.name;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/unionCatalogLogin/unionCatalogLoginInstitutionItem/unionCatalogLoginInstitutionItem.directive.ts